import { render } from "./TheUserAvatar.vue?vue&type=template&id=66fc2981&scoped=true"
import script from "./TheUserAvatar.vue?vue&type=script&lang=js"
export * from "./TheUserAvatar.vue?vue&type=script&lang=js"

import "./TheUserAvatar.vue?vue&type=style&index=0&id=66fc2981&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fc2981"]])

export default __exports__